<template>
    <v-app>
        <leave-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Leave Type List</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">

                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openAddLeaveType"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Leave Type
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.carry_forward="{ item }">
                                            <v-chip v-if="item.carry_forward == 1" color="success" size="small" class="text-capitalize">Yes</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">No</v-chip>     
                                        </template>

                                        <template v-slot:item.gender_allow="{ item }">
                                            <p v-if="item.gender_allow == 0" color="success" size="small" class="text-capitalize">All</p>
                                            <p v-if="item.gender_allow == 1" color="success" size="small" class="text-capitalize">Male</p>
                                            <p v-if="item.gender_allow == 2" color="success" size="small" class="text-capitalize">Female</p>
                                        </template>

                                        <template v-slot:item.half_day_allow="{ item }">
                                            <v-chip v-if="item.half_day_allow == 1" color="success" size="small" class="text-capitalize">Yes</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">No</v-chip>     
                                        </template>

                                        <template v-slot:item.marriage_allow="{ item }">
                                            <p v-if="item.marriage_allow == 1" color="success" size="small" class="text-capitalize">Married</p>
                                            <p v-else color="red" size="small" class="text-capitalize">Unmarried</p>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import leaveSetup from '@/components/module/leave/settings/leaveSetup.vue';
export default {
        components: {
            leaveSetup
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code",align: "left" ,sortable: false },
                { title: "Name", key: "name",align: "left" ,sortable: false },
                { title: "Max Days", key: "max_days", align: "left", sortable: true },
                { title: "Carry Forward",align: "left", key: "carry_forward", sortable: true },
                { title: "Remarks",align: "left", key: "remarks", sortable: true },
                { title: "Gender Allow",align: "left", key: "gender_allow", sortable: true },
                { title: "Marriage Allow",align: "left", key: "marriage_allow", sortable: true },
                { title: "Half Day Allow",align: "left", key: "half_day_allow", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
            if(this.$store.getters.getLeaveTypeList.length == 0){
                this.loading = true;
                this.$store.dispatch('getLeaveTypeList').then((response) => {
                    this.loading = false;
                })
            };
        },
        computed:{
            getSchema() {
                return this.$store.getters.getLeaveTypeList;
            },
        },
        methods: {
            openAddLeaveType() {
                this.data = {
                    id: '',
                    code:'',
                    name: '',
                    max_days:'',
                    carry_forward:'',
                    remarks: '',
                    status: 1,
                };
                this.dialog = true;
            },
            editItem(item){
                this.data = { ...item };
                this.dialog = true;
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Name', 'Mobile','Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.name, item.mobile, item.status == 1 ? 'Active' : 'Inactive']);
                this.$exportTableToPDF(columns,rows,'Warehouse List','warehouse_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Code', 'Name', 'Mobile', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.mobile, item.status == 1 ? 'Active' : 'Inactive']);
                });
                this.$exportTableToExcel(data,'warehouse_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Code', 'Name', 'Mobile', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.name, item.mobile, item.status == 1 ? 'Active' : 'Inactive']);
                });

                this.$exportTableToCSV(data,'warehouse_list_' + this.$fileDate());
            },
        },
        mounted() {

        }  
    }
</script>